import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-cream py-20 px-6 md:py-28 relative overflow-hidden" data-id="element-98">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-100">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-forest mb-6 leading-tight" data-id="element-101">
            The Sunday Reset Rescue Kit
          </h1>
          <p className="md:text-2xl text-charcoal/80 mb-4 font-light max-w-2xl mx-auto text-[18px]" data-id="element-102">
            Self-care didn't fix Sunday. This 22-minute reset actually does.
          </p>
          <p className="md:text-lg text-charcoal/60 mb-10 font-light max-w-2xl mx-auto text-[14px]" data-id="element-103">
            Works on your nervous system. Done before 9PM. No 10-step routine.
          </p>

          <div className="mb-16 relative" data-id="element-104">
            <div className="absolute inset-0 bg-sage/20 blur-3xl rounded-full transform -translate-y-4 scale-110" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ejyTNUxC2Wz7xRr3huBtsN/Mockup_1.png" alt="The Sunday Reset Rescue Kit on an iPad" className="relative z-10 w-full max-w-2xl mx-auto rounded-lg shadow-2xl" data-id="element-106" />
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-gold text-white px-10 py-5 rounded-full text-lg font-medium tracking-wide shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-107">
            Start My Reset
          </motion.button>
        </motion.div>
      </div>
    </section>;
}